import { NextPage } from 'next';
import React from 'react';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import { Info } from '../../components/Info/Info';
import { Requisites } from '../../components/Info/Requisites';
import { tabs } from '../../components/Info/tabs';
import Meta from '../../components/Meta';
import { metaTags } from '../../components/_dummyData';

interface PageProps {}

const RequisitesPage: NextPage<PageProps> = () => {
    useBreadcrumbs([{ title: 'О площадке' }]);

    return (
        <>
            <Meta
                title={metaTags.requisites.title}
                description={metaTags.requisites.description}
                url={metaTags.requisites.url}
            />
            <Info tabs={tabs} activeTab="requisites">
                <Requisites />
            </Info>
        </>
    );
};

export default RequisitesPage;
